export const translations = {
  id: {
    nav: {
      products: "Produk & Layanan",
      calculator: "Kalkulator",
      gallery: "Galeri",
      contact: "Kontak",
      login: "Masuk",
      dashboard: "Dashboard",
      cta: "Hitung & Pesan"
    },
    footer: {
      tag: "Member of Solusi Bangun Indonesia",
      desc: "Platform digital pemesanan beton ready mix pertama di Indonesia. Dari hitung, pesan, hingga pantau — semua di satu platform terintegrasi.",
      product: "Produk",
      address: "Alamat",
      contact: "Kontak",
      help: "FAQ & Bantuan",
      privacy: "Kebijakan Privasi",
      rights: "All rights reserved."
    },
    hero: {
      tag: "Platform Beton Ready Mix Digital",
      title1: "Pesan Beton",
      title2: "Ready Mix",
      title3: "Lebih Mudah",
      sub: "Dari perhitungan volume, pemilihan mutu, hingga pengiriman ke lokasi proyek — semua dalam satu platform digital Solusi Bangun Beton.",
      cta1: "Hitung & Pesan Sekarang",
      cta2: "Konsultasi Gratis"
    },
    stats: {
      projects: "Proyek selesai",
      cities: "Kota terjangkau",
      quality: "Mutu tersedia",
      delivery: "Estimasi pengiriman"
    },
    intro: {
      eyebrow: "Tentang Perusahaan",
      title: "PT Solusi Bangun Beton (SBB)",
      p1: "Bagian dari Solusi Bangun Indonesia (SBI) dan SIG, kami adalah penyedia solusi beton siap pakai (ready-mix) dan produk beton inovatif yang ramah lingkungan. SBB mendukung proyek infrastruktur dengan batching plant strategis.",
      feat1: "Dynamix Beton",
      feat1_sub: "Beton siap pakai berkualitas tinggi untuk berbagai kebutuhan konstruksi.",
      feat2: "Produk Ramah Lingkungan",
      feat2_sub: "Solusi berkelanjutan untuk trotoar dan ruang publik estetis.",
      feat3: "Solusi Konstruksi Khusus",
      feat3_sub: "Beton Ringan, Perbaikan Beton (Epoxy), Patch Repair, dsb.",
      footer: "SBB berkomitmen pada pembangunan berkelanjutan dengan mengutamakan profesionalisme and integritas."
    },
    howItWorks: {
      eyebrow: "Cara Kerja",
      title: "Cara Pesan Beton di Solusi Bangun Beton",
      sub: "7 langkah mudah — dari kebutuhan hingga beton tiba di lokasi.",
      step1: "Input Kebutuhan",
      step1_sub: "Masukkan dimensi atau pilih jenis pekerjaan.",
      step2: "Pilih Mutu",
      step2_sub: "K225, K250, K300+ sesuai kebutuhan struktur.",
      step3: "Tentukan Lokasi",
      step3_sub: "Validasi akses jalan dan estimasi biaya kirim.",
      step4: "Pilih Armada",
      step4_sub: "Standard Truck atau MiniMix (akses sempit).",
      step5: "Jadwal Cor",
      step5_sub: "Pilih tanggal dan jam sesuai kesiapan lapangan.",
      step6: "Checkout",
      step6_sub: "Transfer, termin, atau corporate billing.",
      step7: "Tracking Live",
      step7_sub: "Pantau posisi truk secara real-time via WhatsApp."
    },
    gallery: {
      eyebrow: "Project Portfolio",
      title: "Inspirasi & Bukti Kualitas",
      sub: "Jelajahi berbagai proyek yang telah menggunakan produk beton SBB."
    },
    tracking: {
      eyebrow: "Real-Time Tracking",
      title: "Pantau Pengiriman Beton Anda",
      feat1: "Map Tracking Live",
      feat1_sub: "Update posisi truk setiap 30 detik.",
      feat2: "ETA Akurat",
      feat2_sub: "Berdasarkan lalu lintas Google Maps.",
      feat3: "Notifikasi Otomatis",
      feat3_sub: "WhatsApp blast saat truk menuju lokasi.",
      feat4: "Laporan Digital",
      feat4_sub: "Invoice & DO digital otomatis.",
      orderId: "Tracking Order #SBB-2024-1847",
      distLeft: "Jarak tersisa",
      eta: "Estimasi tiba",
      status: "Status",
      onWay: "Jalan"
    },
    mobileApp: {
      eyebrow: "Aplikasi Mobile",
      title: "Solusi Bangun Beton App",
      desc: "Kemudahan akses dan monitoring pesanan kini ada dalam genggaman Anda. Kelola proyek, pantau pengiriman real-time, dan pesan beton kapan saja dan di mana saja melalui aplikasi resmi kami.",
      feat1Title: "Akses Fleksibel 24/7",
      feat1Desc: "Pesan beton dan jadwalkan pengecoran dengan mudah dan cepat langsung dari smartphone Anda.",
      feat2Title: "Monitoring Pesanan",
      feat2Desc: "Pantau status pesanan dan lacak posisi armada pengiriman secara real-time dari satu dashboard interaktif.",
      alert: "Mohon maaf, aplikasi saat ini masih dalam tahap pengembangan (Under Development)."
    },
    cta: {
      eyebrow: "Mulai Sekarang",
      title: "Siap Memulai Proyek Anda?",
      cta1: "Hitung & Pesan Sekarang",
      cta2: "WhatsApp Konsultasi",
      trust1: "Tersertifikasi",
      trust2: "Quality Mgmt",
      trust3: "Proyek selesai",
      rating: "Rating"
    },
    calc: {
      eyebrow: "SMART CALCULATION ENGINE",
      title: "Hitung Kebutuhan Beton Presisi",
      lead: "Hindari kekurangan beton di lapangan dengan sistem perhitungan yang mempertimbangkan waste factor sesuai jenis konstruksi.",
      header: "Dimensi & Jenis Proyek",
      label1: "Apa yang akan Anda cor?",
      labelP: "Panjang (m)",
      labelL: "Lebar (m)",
      labelT: "Ketebalan (cm)",
      wasteMsg: "Waste factor otomatis ditambahkan untuk toleransi penuangan.",
      emptyTitle: "Menunggu Input Anda",
      emptySub: "Masukkan dimensi panjang, lebar, dan tebal untuk melihat hasil estimasi volume beton.",
      needed: "Beton Dibutuhkan",
      recom: "Rekomendasi",
      baseVol: "Volume Dasar",
      waste: "Waste",
      truckStd: "Armada Standard",
      truckMini: "Armada MiniMix",
      warning: "Harga final bergantung pada jarak lokasi proyek.",
      addCart: "Tambah ke Keranjang",
      browse: "Cari Produk Lain",
      ctaSub: "Atau simpan hasil ini untuk konsultasi.",
      jobs: {
        dak: "Dak",
        jalan: "Jalan",
        pondasi: "Pondasi",
        kolom: "Kolom",
        lainnya: "Lainnya"
      }
    },
    products: {
      eyebrow: "DYNAMIX BETON CATALOG",
      title: "Katalog Produk & Layanan",
      lead: "Pilih solusi beton yang tepat untuk proyek Anda. Gunakan filter untuk membantu Anda menemukan mutu beton dan jenis pengiriman yang sesuai.",
      search: "Cari Produk",
      searchPlaceholder: "Contoh: K250, Dak rumah...",
      categories: "Kategori Produk",
      mutu: "Mutu Beton",
      trucks: "Jenis Armada",
      loading: "Memuat katalog produk...",
      empty: "Produk tidak ditemukan dengan filter tersebut.",
      startFrom: "Mulai dari",
      contactSales: "Hubungi Sales",
      unit: "/m³",
      all: "Semua",
      recomUse: "Rekomendasi Penggunaan",
      quickCalc: "Kalkulasi Cepat",
      calcMsg: "Gunakan kalkulator untuk estimasi volume yang dibutuhkan.",
      openCalc: "Buka Kalkulator Volume",
      estPrice: "Estimasi Harga (Jabodetabek)",
      priceNote: "*Harga dapat berubah sesuai lokasi dan volume.",
      addCart: "Tambah ke Keranjang",
      requestOffer: "Minta Penawaran Khusus",
      procTitle: "Prosedur Pemesanan & Layanan",
      proc1Title: "1. Konsultasi & Cek Stok",
      proc1Desc: "Hubungi tim sales kami untuk konfirmasi ketersediaan stok produk dan jangkauan batching plant terdekat.",
      proc2Title: "2. Survey Lokasi",
      proc2Desc: "Tim teknis kami akan melakukan survey untuk memastikan akses jalan dan kelayakan lokasi pengecoran.",
      proc3Title: "3. Penjadwalan",
      proc3Desc: "Konfirmasi jadwal pengiriman H-3 untuk memastikan ketersediaan armada dan kelancaran suplai.",
      proc4Title: "4. Jaminan Kualitas",
      proc4Desc: "Setiap pengiriman disertai dengan dokumen uji mutu (test report) dari laboratorium resmi kami."
    },
    cart: {
      back: "Kembali Belanja",
      title1: "Keranjang Anda",
      title2: "Detail Pengiriman",
      step1: "1. Review",
      step2: "2. Pengiriman",
      step3: "3. Selesai",
      emptyTitle: "Keranjang Kosong",
      emptySub: "Anda belum menambahkan produk beton ke dalam keranjang.",
      viewCatalog: "Lihat Katalog Produk",
      summary: "Ringkasan Pesanan",
      subtotal: "Subtotal Produk",
      delivery: "Biaya Kirim & Pompa",
      calcLater: "Akan dihitung sales",
      estTotal: "Estimasi Total",
      next: "Lanjut ke Pengiriman",
      note: "Harga final akan dikirimkan melalui penawaran resmi (Quotation) setelah tim kami melakukan verifikasi lokasi dan jadwal.",
      trust1: "Pembayaran Aman",
      trust2: "Survey Lokasi Gratis",
      trust3: "Dukungan Teknis 24/7",
      item: {
        volume: "Volume (m³)",
        unit: "/m³",
        total: "Subtotal"
      },
      form: {
        contact: "Informasi Kontak",
        name: "Nama Lengkap",
        phone: "No. WhatsApp",
        email: "Email",
        project: "Detail Proyek",
        projectName: "Nama Proyek / Keterangan",
        address: "Alamat Lengkap Proyek",
        date: "Rencana Tanggal Cor",
        time: "Jam Mulai Cor",
        options: "Opsi Tambahan",
        pump: "Butuh Pompa Beton (Concrete Pump)?",
        pumpSub: "Centang jika pengecoran dilakukan di lantai 2 ke atas atau area yang sulit dijangkau belalai truk.",
        back: "Kembali",
        submit: "Kirim Permintaan Penawaran (Quotation)",
        sending: "Mengirim..."
      },
      success: {
        title: "Permintaan Terkirim!",
        desc: "Terima kasih. Permintaan penawaran Anda telah kami terima. Tim sales kami akan menghubungi Anda melalui WhatsApp dalam waktu maksimal 30 menit untuk konfirmasi lokasi dan jadwal.",
        back: "Kembali ke Beranda",
        checkOrder: "Cek Pesanan",
        whatsapp: "Chat via WhatsApp"
      }
    },
    auth: {
      loginTitle: "Masuk ke Akun Anda",
      loginSub: "Akses dashboard untuk memantau pesanan dan riwayat transaksi.",
      loginSubShort: "Masuk untuk melanjutkan sesi Anda.",
      email: "Email",
      password: "Password",
      forgot: "Lupa password?",
      submit: "Masuk Sekarang",
      login: "Masuk",
      noAccount: "Belum punya akun?",
      register: "Daftar di sini",
      regTitle: "Daftar Akun Baru",
      regSub: "Mulai pesan beton dengan lebih mudah dan pantau progres proyek Anda.",
      regSubShort: "Isi data di bawah untuk membuat akun baru.",
      regSubmit: "Buat Akun",
      name: "Nama Lengkap",
      phone: "No. WhatsApp",
      haveAccount: "Sudah punya akun?",
      regSuccessAlert: "Registrasi berhasil! Silakan login dengan akun Anda."
    },
    portal: {
      dashboard: "Dashboard",
      orders: "Riwayat Order",
      sub: "Portal Pelanggan",
      welcome: "Selamat datang",
      backToWeb: "Kembali ke Website",
      logout: "Keluar",
      orderBtn: "Pesan Beton",
      loading: "Memuat data...",
      activeOrder: "Pengiriman Sedang Berlangsung!",
      monitorNow: "Pantau Sekarang",
      stats: {
        orders: "Total Pesanan",
        volume: "Total Volume",
        spend: "Total Belanja",
        rating: "Rating Anda"
      },
      recentOrders: "Pesanan Terbaru",
      seeAll: "Lihat Semua",
      filterAll: "Semua",
      status: {
        dispatched: "Dalam Pengiriman",
        completed: "Selesai",
        invoiced: "Ditagih",
        batching: "Sedang Dibuat",
        approved: "Disetujui"
      },
      tracking: {
        title: "Pelacakan Live Armada",
        driver: "Pengemudi",
        eta: "ETA",
        start: "Berangkat",
        onWay: "Dalam Perjalanan",
        arrived: "Tiba di Lokasi"
      },
      detail: {
        back: "Kembali ke Daftar Pesanan",
        shippingStatus: "Status Pengiriman",
        summary: "Ringkasan Pesanan",
        project: "Proyek",
        plant: "Batching Plant",
        date: "Tanggal Pesanan",
        payStatus: "Status Pembayaran",
        paid: "Lunas",
        total: "Total Estimasi",
        download: "Download Invoice",
        contactCS: "Hubungi Customer Service",
        projectInfo: "Informasi Proyek & Pengiriman",
        customerName: "Nama Pemesan",
        phone: "No. WhatsApp",
        email: "Email",
        address: "Alamat Proyek",
        items: "Daftar Item Pesanan",
        itemProduct: "Produk",
        itemQty: "Volume",
        itemPrice: "Harga Satuan",
        itemSub: "Subtotal",
        review: "Beri Ulasan"
      },
      suggestion: {
        title: "Kotak Saran",
        desc: "Pendapat Anda sangat berarti untuk meningkatkan kualitas layanan kami",
        category: "Kategori Saran",
        selectCat: "Pilih kategori...",
        rating: "Rating Pengalaman",
        message: "Pesan / Saran Anda",
        messagePlaceholder: "Tuliskan saran, kritik, atau masukan Anda di sini secara detail...",
        anon: "Kirim secara anonim (identitas tidak akan ditampilkan)",
        submit: "Kirim Saran",
        successTitle: "Terima Kasih!",
        successDesc: "Saran Anda telah berhasil dikirim. Tim kami akan meninjau dan menindaklanjutinya.",
        sendOther: "Kirim Saran Lainnya"
      },
      profile: {
        title: "Profil Saya",
        edit: "Edit Profil",
        cancel: "Batal",
        personalData: "Data Pribadi",
        fullName: "Nama Lengkap",
        phone: "Nomor HP/WA",
        email: "Alamat Email",
        company: "Nama Perusahaan",
        custType: "Tipe Pelanggan",
        address: "Alamat Proyek Utama",
        save: "Simpan Perubahan",
        security: "Keamanan Akun",
        changePass: "Ganti Password",
        verifyWA: "Verifikasi WhatsApp",
        twoFactor: "Autentikasi 2FA",
        loyaltyTier: "Pelanggan Setia",
        points: "Poin"
      }
    }
  },
  en: {
    nav: {
      products: "Products & Services",
      calculator: "Calculator",
      gallery: "Gallery",
      contact: "Contact",
      login: "Login",
      dashboard: "Dashboard",
      cta: "Calculate & Order"
    },
    footer: {
      tag: "Member of Solusi Bangun Indonesia",
      desc: "First digital platform for ready mix concrete ordering in Indonesia. From calculation, order, to monitoring — all in one integrated platform.",
      product: "Products",
      address: "Address",
      contact: "Contact",
      help: "FAQ & Help",
      privacy: "Privacy Policy",
      rights: "All rights reserved."
    },
    hero: {
      tag: "Digital Ready Mix Concrete Platform",
      title1: "Order Concrete",
      title2: "Ready Mix",
      title3: "More Easily",
      sub: "From volume calculation, strength selection, to project site delivery — all in one digital platform Solusi Bangun Beton.",
      cta1: "Calculate & Order Now",
      cta2: "Free Consultation"
    },
    stats: {
      projects: "Projects completed",
      cities: "Cities covered",
      quality: "Grades available",
      delivery: "Delivery estimate"
    },
    intro: {
      eyebrow: "About Company",
      title: "PT Solusi Bangun Beton (SBB)",
      p1: "Part of Solusi Bangun Indonesia (SBI) and SIG, we are providers of ready-mix concrete solutions and innovative eco-friendly concrete products. SBB supports infrastructure projects with strategic batching plants.",
      feat1: "Dynamix Concrete",
      feat1_sub: "High-quality ready-mix concrete for various construction needs.",
      feat2: "Eco-Friendly Products",
      feat2_sub: "Sustainable solutions for sidewalks and aesthetic public spaces.",
      feat3: "Special Construction Solutions",
      feat3_sub: "Lightweight Concrete, Concrete Repair (Epoxy), Patch Repair, etc.",
      footer: "SBB is committed to sustainable development by prioritizing professionalism and integrity."
    },
    howItWorks: {
      eyebrow: "How It Works",
      title: "How to Order Concrete at Solusi Bangun Beton",
      sub: "7 easy steps — from requirement to concrete arrival at site.",
      step1: "Input Requirements",
      step1_sub: "Enter dimensions or select project type.",
      step2: "Select Grade",
      step2_sub: "K225, K250, K300+ according to structure needs.",
      step3: "Set Location",
      step3_sub: "Validate road access and estimate delivery cost.",
      step4: "Select Truck",
      step4_sub: "Standard Truck or MiniMix (narrow access).",
      step5: "Schedule Pouring",
      step5_sub: "Select date and time according to site readiness.",
      step6: "Checkout",
      step6_sub: "Transfer, terms, or corporate billing.",
      step7: "Live Tracking",
      step7_sub: "Monitor truck position in real-time via WhatsApp."
    },
    gallery: {
      eyebrow: "Project Portfolio",
      title: "Inspiration & Proof of Quality",
      sub: "Explore various projects that have used SBB concrete products."
    },
    tracking: {
      eyebrow: "Real-Time Tracking",
      title: "Monitor Your Concrete Delivery",
      feat1: "Live Map Tracking",
      feat1_sub: "Truck position updates every 30 seconds.",
      feat2: "Accurate ETA",
      feat2_sub: "Based on Google Maps traffic.",
      feat3: "Auto Notification",
      feat3_sub: "WhatsApp blast when truck heads to site.",
      feat4: "Digital Reports",
      feat4_sub: "Automatic digital Invoice & DO.",
      orderId: "Tracking Order #SBB-2024-1847",
      distLeft: "Distance left",
      eta: "Estimate arrival",
      status: "Status",
      onWay: "On the way"
    },
    mobileApp: {
      eyebrow: "Mobile Application",
      title: "Solusi Bangun Beton App",
      desc: "Ease of access and order monitoring is now in your hands. Manage projects, monitor real-time delivery, and order concrete anytime and anywhere through our official app.",
      feat1Title: "24/7 Flexible Access",
      feat1Desc: "Order concrete and schedule pouring easily and quickly right from your smartphone.",
      feat2Title: "Order Monitoring",
      feat2Desc: "Monitor order status and track fleet positions in real-time from a single interactive dashboard.",
      alert: "We apologize, the application is currently under development."
    },
    cta: {
      eyebrow: "Start Now",
      title: "Ready to Start Your Project?",
      cta1: "Calculate & Order Now",
      cta2: "WhatsApp Consultation",
      trust1: "Certified",
      trust2: "Quality Mgmt",
      trust3: "Projects completed",
      rating: "Rating"
    },
    calc: {
      eyebrow: "SMART CALCULATION ENGINE",
      title: "Precise Concrete Calculation",
      lead: "Avoid concrete shortage on site with a calculation system that considers waste factor according to construction type.",
      header: "Dimensions & Project Type",
      label1: "What will you pour?",
      labelP: "Length (m)",
      labelL: "Width (m)",
      labelT: "Thickness (cm)",
      wasteMsg: "Waste factor automatically added for pouring tolerance.",
      emptyTitle: "Waiting for Your Input",
      emptySub: "Enter length, width, and thickness dimensions to see the estimated concrete volume.",
      needed: "Concrete Needed",
      recom: "Recommendation",
      baseVol: "Base Volume",
      waste: "Waste",
      truckStd: "Standard Truck",
      truckMini: "MiniMix Truck",
      warning: "Final price depends on project site distance.",
      addCart: "Add to Cart",
      browse: "Browse Other Products",
      ctaSub: "Or save this result for consultation.",
      jobs: {
        dak: "Slab",
        jalan: "Road",
        pondasi: "Foundation",
        kolom: "Column",
        lainnya: "Others"
      }
    },
    products: {
      eyebrow: "DYNAMIX BETON CATALOG",
      title: "Products & Services Catalog",
      lead: "Choose the right concrete solution for your project. Use filters to help you find the right concrete grade and delivery type.",
      search: "Search Products",
      searchPlaceholder: "Example: K250, Slab...",
      categories: "Product Categories",
      mutu: "Concrete Grade",
      trucks: "Truck Type",
      loading: "Loading product catalog...",
      empty: "No products found with those filters.",
      startFrom: "Starting from",
      contactSales: "Contact Sales",
      unit: "/m³",
      all: "All",
      recomUse: "Recommended Use",
      quickCalc: "Quick Calculation",
      calcMsg: "Use the calculator to estimate the volume needed.",
      openCalc: "Open Volume Calculator",
      estPrice: "Estimated Price (Jabodetabek)",
      priceNote: "*Price may change according to location and volume.",
      addCart: "Add to Cart",
      requestOffer: "Request Custom Offer",
      procTitle: "Ordering & Service Procedures",
      proc1Title: "1. Consultation & Stock Check",
      proc1Desc: "Contact our sales team to confirm product stock availability and nearest batching plant coverage.",
      proc2Title: "2. Site Survey",
      proc2Desc: "Our technical team will conduct a survey to ensure road access and pouring site feasibility.",
      proc3Title: "3. Scheduling",
      proc3Desc: "Confirm delivery schedule H-3 to ensure truck availability and smooth supply.",
      proc4Title: "4. Quality Assurance",
      proc4Desc: "Every delivery is accompanied by quality test documents (test report) from our official laboratory."
    },
    cart: {
      back: "Back to Shopping",
      title1: "Your Cart",
      title2: "Delivery Details",
      step1: "1. Review",
      step2: "2. Delivery",
      step3: "3. Finish",
      emptyTitle: "Empty Cart",
      emptySub: "You haven't added any concrete products to your cart yet.",
      viewCatalog: "View Product Catalog",
      summary: "Order Summary",
      subtotal: "Product Subtotal",
      delivery: "Delivery & Pump Fee",
      calcLater: "Calculated by sales",
      estTotal: "Estimated Total",
      next: "Continue to Delivery",
      note: "Final price will be sent via official offer (Quotation) after our team verifies location and schedule.",
      trust1: "Secure Payment",
      trust2: "Free Site Survey",
      trust3: "24/7 Technical Support",
      item: {
        volume: "Volume (m³)",
        unit: "/m³",
        total: "Subtotal"
      },
      form: {
        contact: "Contact Information",
        name: "Full Name",
        phone: "WhatsApp No.",
        email: "Email",
        project: "Project Details",
        projectName: "Project Name / Description",
        address: "Full Project Address",
        date: "Planned Pouring Date",
        time: "Pouring Start Time",
        options: "Additional Options",
        pump: "Need Concrete Pump?",
        pumpSub: "Check if pouring is done on 2nd floor or above, or areas difficult to reach by truck boom.",
        back: "Back",
        submit: "Send Request for Quotation",
        sending: "Sending..."
      },
      success: {
        title: "Request Sent!",
        desc: "Thank you. Your request for quotation has been received. Our sales team will contact you via WhatsApp within a maximum of 30 minutes to confirm location and schedule.",
        back: "Back to Home",
        checkOrder: "Check Order Status",
        whatsapp: "Chat via WhatsApp"
      }
    },
    auth: {
      loginTitle: "Login to Your Account",
      loginSub: "Access the dashboard to monitor orders and transaction history.",
      loginSubShort: "Sign in to continue your session.",
      email: "Email",
      password: "Password",
      forgot: "Forgot password?",
      submit: "Login Now",
      login: "Login",
      noAccount: "Don't have an account?",
      register: "Register here",
      regTitle: "Register New Account",
      regSub: "Start ordering concrete more easily and monitor your project progress.",
      regSubShort: "Fill in the details below to create your account.",
      regSubmit: "Create Account",
      name: "Full Name",
      phone: "WhatsApp No.",
      haveAccount: "Already have an account?",
      regSuccessAlert: "Registration successful! Please login with your account."
    },
    portal: {
      dashboard: "Dashboard",
      orders: "Order History",
      sub: "Customer Portal",
      welcome: "Welcome",
      backToWeb: "Back to Website",
      logout: "Logout",
      orderBtn: "Order Concrete",
      loading: "Loading data...",
      activeOrder: "Delivery in Progress!",
      monitorNow: "Monitor Now",
      stats: {
        orders: "Total Orders",
        volume: "Total Volume",
        spend: "Total Spending",
        rating: "Your Rating"
      },
      recentOrders: "Recent Orders",
      seeAll: "See All",
      filterAll: "All",
      status: {
        dispatched: "On Delivery",
        completed: "Completed",
        invoiced: "Invoiced",
        batching: "In Batching",
        approved: "Approved"
      },
      tracking: {
        title: "Live Fleet Tracking",
        driver: "Driver",
        eta: "ETA",
        start: "Departed",
        onWay: "On the way",
        arrived: "Arrived at site"
      },
      detail: {
        back: "Back to Orders",
        shippingStatus: "Shipping Status",
        summary: "Order Summary",
        project: "Project",
        plant: "Batching Plant",
        date: "Order Date",
        payStatus: "Payment Status",
        paid: "Paid",
        total: "Estimated Total",
        download: "Download Invoice",
        contactCS: "Contact Support",
        projectInfo: "Project & Delivery Information",
        customerName: "Customer Name",
        phone: "WhatsApp No",
        email: "Email",
        address: "Project Address",
        items: "Order Items List",
        itemProduct: "Product",
        itemQty: "Volume",
        itemPrice: "Unit Price",
        itemSub: "Subtotal",
        review: "Leave a Review"
      },
      suggestion: {
        title: "Suggestion Box",
        desc: "Your opinion matters to improve our service quality",
        category: "Suggestion Category",
        selectCat: "Select category...",
        rating: "Experience Rating",
        message: "Your Message / Suggestion",
        messagePlaceholder: "Write your suggestions, criticism, or feedback here in detail...",
        anon: "Send anonymously (identity will not be displayed)",
        submit: "Send Suggestion",
        successTitle: "Thank You!",
        successDesc: "Your suggestion has been successfully sent. Our team will review and follow up.",
        sendOther: "Send Another Suggestion"
      },
      profile: {
        title: "My Profile",
        edit: "Edit Profile",
        cancel: "Cancel",
        personalData: "Personal Data",
        fullName: "Full Name",
        phone: "Phone/WA Number",
        email: "Email Address",
        company: "Company Name",
        custType: "Customer Type",
        address: "Primary Project Address",
        save: "Save Changes",
        security: "Account Security",
        changePass: "Change Password",
        verifyWA: "Verify WhatsApp",
        twoFactor: "2FA Authentication",
        loyaltyTier: "Loyal Customer",
        points: "Points"
      }
    }
  }
};
